__turbopack_context__.v({
  "media": "Xy9NzG_media",
  "media-container": "Xy9NzG_media-container",
});
